/**
 * LocalStorage Utility Functions
 * Güvenli localStorage işlemleri için yardımcı fonksiyonlar
 */

/**
 * LocalStorage'dan güvenli şekilde JSON parse et
 */
export const getStorageItem = <T = any>(key: string, defaultValue: T | null = null): T | null => {
  try {
    const item = localStorage.getItem(key);
    
    // Değer yoksa veya geçersizse default döndür
    if (!item || item === 'undefined' || item === 'null') {
      return defaultValue;
    }
    
    return JSON.parse(item) as T;
  } catch (error) {
    console.error(`Error parsing localStorage item "${key}":`, error);
    return defaultValue;
  }
};

/**
 * LocalStorage'a güvenli şekilde kaydet
 */
export const setStorageItem = (key: string, value: any): void => {
  try {
    if (value === undefined || value === null) {
      localStorage.removeItem(key);
    } else {
      localStorage.setItem(key, JSON.stringify(value));
    }
  } catch (error) {
    console.error(`Error setting localStorage item "${key}":`, error);
  }
};

/**
 * LocalStorage'dan öğe sil
 */
export const removeStorageItem = (key: string): void => {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.error(`Error removing localStorage item "${key}":`, error);
  }
};

/**
 * Tüm admin storage'ı temizle
 */
export const clearAdminStorage = (): void => {
  removeStorageItem('admin_token');
  removeStorageItem('admin_info');
};

/**
 * Admin bilgilerini al
 */
export const getAdminInfo = (): any => {
  return getStorageItem('admin_info', {});
};

/**
 * Admin token'ı al
 */
export const getAdminToken = (): string | null => {
  return getStorageItem('admin_token', null);
};

